import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { FacetRadioButton } from '@wix/da-ds/pkg/FacetList/Facet';
import {
  FacetListRow,
  FacetListGrid,
} from '@wix/da-shared-react/pkg/FacetList';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import { FormField } from '../../redux/types';
import { exclusiveCategoriesFormData } from '../../constants';
import s from './ExclusiveCategoryRadioButtons.scss';

interface Props {
  className?: string;
  sliderContentClassName?: string;
}

const ExclusiveCategoryRadioButtons: React.FC<Props> = ({
  className,
  sliderContentClassName,
}) => {
  const isMobile = useContext(MobileContext);
  const { t } = useTranslation();
  const { control } = useFormContext();
  const {
    field: {
      onChange: controllerOnChange,
      value,
      // ref doesn't need passed through to the input, so pulling it out
      ref,
      ...remainingInputProps
    },
  } = useController({
    name: FormField.Category,
    control,
    rules: {
      required: true,
    },
  });

  const facets = Object.values(exclusiveCategoriesFormData).map(category => (
    <FacetRadioButton
      key={category.categoryKey}
      size="medium"
      value={category.necoId}
      selected={category.necoId === value}
      onChange={e => {
        controllerOnChange(e);
        e.stopPropagation();
      }}
      {...remainingInputProps}
    >
      {t(category.translationKey)}
    </FacetRadioButton>
  ));

  return (
    <div className={c(s['root'], className)}>
      <InputLabelText className={s['label']}>
        {t('sellerModal.create.exclusive_category.label')}
      </InputLabelText>
      {isMobile ? (
        <FacetListRow
          facets={facets}
          contentClassName={sliderContentClassName}
        />
      ) : (
        <FacetListGrid columns={4} gap={6} facets={facets} />
      )}
    </div>
  );
};

ExclusiveCategoryRadioButtons.displayName = 'ExclusiveCategoryRadioButtons';

export default ExclusiveCategoryRadioButtons;
